import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
    selector: "app-out-of-zone-alert",
    templateUrl: "./out-of-zone-alert.component.html",
    styleUrls: ["./out-of-zone-alert.component.scss"],
})
export class OutOfZoneAlertComponent implements OnInit {
    @Output() onCheck: EventEmitter<boolean> = new EventEmitter();

    constructor(public activeModal: NgbActiveModal) {}

    ngOnInit(): void {}

    onConfirm() {
        const checkboxInput = document.querySelector(
            ".checkboxInput",
        ) as HTMLInputElement;
        if (checkboxInput.checked) {
            this.onCheck.emit(true);
        } else {
            this.onCheck.emit(false);
        }
        this.activeModal.close();
    }
}
